<input  class="titleToData" placeholder="{{'questionBoard.edit.titleToData' | translate}}" [formControl]="titleToData" [maxLength]="35">
<div class="question-title asterisk xx">
    <svg-icon *ngIf="question?.requierd" svgClass="svg-img-mini img"
        src="/assets/images/question-menu/asterisk.svg"></svg-icon>
    <img *ngIf="question?.type?.image" class="image-type" src="/assets/images/types/{{question?.type?.image}}" />
    <textarea autoresize queDisplayByType [name]="'inputTitle'" [typeId]="typeId"
        placeholder="{{'questionBoard.edit.questionCome' | translate}}" [formControl]="title"
        [style.color]="color$ | async">
        </textarea>
    <textarea autoresize queDisplayByType [name]="'inputTitleToImage'" [typeId]="typeId"
        placeholder="{{'questionBoard.edit.questionComeImage' | translate}}" [formControl]="title"
        [style.color]="color$ | async">
    </textarea>
</div>
<div class="text" queDisplayByType [name]="'textInTexts'" [typeId]="typeId">
    <textarea autoresize placeholder="{{'questionBoard.edit.description' | translate}}" [formControl]="text">
    </textarea>
</div>